<div class="view-navbar" *ngIf="isPaginated || isAnimated">
  <div class="view-navbar__inner">
    <app-pillbox [padding]="isPaginated || showScrubber ? 'dense' : 'none'">
      <app-view-media-bar *ngIf="isAnimated && isVisible(viewLayout.Media)" [showScrubber]="showScrubber"></app-view-media-bar>
      
      <ng-container *ngIf="(chapterCount$ | async) > 1">
        <app-pin-button
          class="mr-1"
          type="ghost"
          icon="arrow-left"
          (click)="handlePreviousChapter()"
          [disabled]="(chapterIndex$ | async) === 0"
          [matTooltip]="previousChapterLabel"
          matTooltipPosition="above">
        </app-pin-button>
    
        <app-pin-button
          type="ghost"
          icon="arrow-right"
          (click)="handleNextChapter()"
          [disabled]="(chapterIndex$ | async) === ((chapterCount$ | async) - 1)"
          [matTooltip]="nextChapterLabel"
          matTooltipPosition="above">
        </app-pin-button>
      </ng-container>
    </app-pillbox>
  </div>
</div>